const STORAGE_KEY = 'plan_expiry_popup_shown_date';

const today = () => new Date().toISOString().slice(0, 10); // "YYYY-MM-DD"

export function hasShownToday(): boolean {
    return localStorage.getItem(STORAGE_KEY) === today();
}

export function markShownToday(): void {
    localStorage.setItem(STORAGE_KEY, today());
}
